const styles = {
  wrapper: {
    outline: 'none',
    lineHeight: 1,
    background: 'white',
    maxWidth: {
      sm: '360px',
      sm: '439px',
    },
    width: '100%',
    borderRadius: {
      xs: '0',
      sm: '16px',
    },
    padding: {
      xs: '36px 16px 24px 16px',
      md: '32px 48px 40px 48px',
    },
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  close: {
    zIndex: 1,
    padding: 0,
    width: '16px',
    height: '16px',
    fontSize: 0,
    position: 'absolute',
    top: {
      xs: '30px',
      md: '30px',
    },
    right: {
      xs: '22px',
      md: '22px',
    },
    minWidth: 'unset',
    '&::before': {
      background: 'currentColor',
      content: '""',
      height: '2px',
      left: '0',
      position: 'absolute',
      top: '50%',
      width: '100%',
      transform: 'translateY(-50%) rotate(-45deg)',
    },
    '&::after': {
      background: 'currentColor',
      content: '""',
      height: '2px',
      left: '0',
      position: 'absolute',
      top: '50%',
      width: '100%',
      transform: 'translateY(-50%) rotate(45deg)',
    },
  },
};

export default styles;
